import { createContext, Dispatch, SetStateAction } from 'react'

import { Alert, AlertFilter } from 'AlertsOfVulnerability/types'
import { Pagination, VisualizationKeyString } from 'types'
import { ALERT_INITIAL_FILTER, ALERT_INITIAL_PAGINATION } from 'AlertsOfVulnerability/constants/pages/alerts'

type AlertManagerContext = {
  alerts: Alert[]
  loadingAlerts: boolean
  filter: AlertFilter
  visualization: VisualizationKeyString
  pagination: Pagination
  totalItems: number
  reloadAlerts: () => Promise<void>
  setFilterAndResetPagination: any
  setVisualization: Dispatch<SetStateAction<VisualizationKeyString>>
  setPagination: Dispatch<SetStateAction<Pagination>>
  setAlerts: Dispatch<SetStateAction<Alert[]>>
  setTotalItems: Dispatch<SetStateAction<number>>
  visualizationType?: string
  setVisualizationType?: Dispatch<SetStateAction<string>>
  visualizationTypeStorageKey: string
}

const defaultValue = {
  alerts: [],
  loadingAlerts: false,
  filter: ALERT_INITIAL_FILTER,
  visualization: {},
  pagination: ALERT_INITIAL_PAGINATION,
  totalItems: 0,
  reloadAlerts: async () => {},
  setFilterAndResetPagination: () => {},
  setVisualization: () => {},
  setPagination: () => {},
  setAlerts: () => {},
  setTotalItems: () => {},
  visualizationType: '',
  setVisualizationType: () => {},
  visualizationTypeStorageKey: '',
}

const AlertManagerContext = createContext<AlertManagerContext>(defaultValue)

export default AlertManagerContext
